import { Td as ChakraTd, Text } from '@chakra-ui/react'

export const Td = ({ textAlign = 'center', bg, py = 1, children, ...props }) => (
  <ChakraTd textAlign={textAlign} px={2} mx={0} py={py} bg={bg} {...props}>
    <Text
      mx="auto"
      fontSize="12px"
      textTransform="capitalize"
      //força o texto na mesma linha
      whiteSpace="nowrap"
    >
      {children}
    </Text>
  </ChakraTd>
)
